module.exports = __webpack_public_path__ + "media/images/vp/no.img-ef5527f5fa91d3e7c79098c809bc1563.png";